import classes from "./stage4.module.css";
import Button from "../../../components/UI/Button/button";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import {
  companyAdditionalInfo,
  companyProfile,
} from "../../../services/clientCalls";
import { UserContext } from "../../../context";
import { errorHandler } from "../../../utils";
import { validateSocialField } from "../../../utils/functions";
import PanelHero from "../PanelHero/PanelHero";
import { IconChevronsLeft, IconShare } from "@tabler/icons-react";
import s from "../steps.module.css";
import Input, { Textarea } from "../../../components/UI/FormInput/input";

const Stage2 = () => {
  const { setCount } = useContext(UserContext);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [infoData, setInfoData] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({
    facebookUrl: "",
    linkedInUrl: "",
    instagramUrl: "",
    twitterUrl: "",
    summary: "",
  });

  const submit = async (e) => {
    e.preventDefault();

    if (!validateUrls()) {
      return;
    }

    try {
      setLoad(true);
      const res = await companyAdditionalInfo(data);

      setCount(3);
      navigate({
        pathname: "/client-onboarding",
        search: "stage=5",
      });
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  const getCompanyProfile = async () => {
    try {
      const res = await companyProfile();
      setData(res.data.data.client);
      setLoad(false);
    } catch (error) {
      setLoad(false);
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    }
  };

  useEffect(() => {
    getCompanyProfile();
  }, []);

  useEffect(() => {
    if (infoData) {
      setData((prevState) => ({
        ...prevState,
        facebookUrl: infoData.facebookUrl ?? "",
        linkedInUrl: infoData.linkedInUrl ?? "",
        instagramUrl: infoData.instagramUrl ?? "",
        twitterUrl: infoData.twitterUrl ?? "",
        summary: infoData.summary ?? "",
      }));
    }
  }, [infoData]);

  const validateUrls = () => {
    const { facebookUrl, linkedInUrl, twitterUrl, instagramUrl } = data;
    const errors = [];

    const fieldsToValidate = [
      { name: "facebook", value: facebookUrl },
      { name: "linkedin", value: linkedInUrl },
      { name: "twitter", value: twitterUrl },
      { name: "instagram", value: instagramUrl },
    ];

    fieldsToValidate.forEach(({ name, value }) => {
      if (value) {
        const errorMsg = validateSocialField(name, value);
        if (errorMsg) {
          errors.push(errorMsg);
        }
      }
    });

    if (errors.length > 0) {
      errorHandler("Invalid URL", "Error");
      return false;
    }
    return true;
  };

  const handleChange = (e, platform) => {
    const { name, value } = e.target;

    // Update the field value
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Handle validation or clear error
    setErrors((prev) => ({
      ...prev,
      [name]: value === "" ? "" : validateSocialField(platform, value),
    }));
  };

  return (
    <>
      <PanelHero
        icon={<IconShare />}
        title="Additional Information"
        subtitle="Please provide us with some more information on your company"
      />

      <form onSubmit={submit}>
        <div className={s.panelBody}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <Input
              type="text"
              label="Facebook URL"
              htmlFor="facebookUrl"
              id="facebookUrl"
              name="facebookUrl"
              placeholder="https://facebook.com/yourcompany"
              value={data.facebookUrl}
              error={errors.facebookUrl}
              onChange={(e) => handleChange(e, "facebook")}
            />
            <Input
              type="text"
              label="LinkedIn URL"
              htmlFor="linkedInUrl"
              id="linkedInUrl"
              name="linkedInUrl"
              placeholder="https://linkedin.com/company/…"
              value={data.linkedInUrl}
              error={errors.linkedInUrl}
              onChange={(e) => handleChange(e, "linkedIn")}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <Input
              type="text"
              label="Twitter/X URL"
              htmlFor="twitterUrl"
              id="twitterUrl"
              name="twitterUrl"
              placeholder="https://x.com/yourhandle"
              value={data.twitterUrl}
              error={errors.twitterUrl}
              onChange={(e) => handleChange(e, "twitter")}
            />
            <Input
              type="text"
              label="Instagram URL"
              htmlFor="instagramUrl"
              id="instagramUrl"
              name="instagramUrl"
              placeholder="https://instagram.com/yourcompany"
              value={data.instagramUrl}
              error={errors.instagramUrl}
              onChange={(e) => handleChange(e, "instagram")}
            />
          </div>

          <Textarea
            label="Summary about your company"
            id="summary"
            maxLength={500}
            value={data.summary}
            error={errors.summary}
            rows={4}
            onChange={(e) => setData({ ...data, summary: e.target.value })}
          />
        </div>

        <div className={s.panelFooter}>
          <div className={s.footerNote}>
            <Button
              variant="ghost"
              leftIcon={<IconChevronsLeft size={15} />}
              onClick={() => navigate(-1)}
              disabled={load}
            >
              Back
            </Button>
          </div>
          <div className={s.footerActions}>
            <Button onClick={submit} disabled={load} loading={load}>
              Continue
            </Button>
          </div>
        </div>
      </form>
    </>
  );
};

export default Stage2;
